export default "__VITE_ASSET__CNEHkujM__";